import Vue from 'vue'

import app from './app'
import footer from './footer'
import layout from './layout'

export default Vue.observable({
  app,
  footer,
  layout
})
